import React from 'react'
import "./SubEventCard.css"
import {Link} from "react-router-dom" 
import UploadFiles from '../../pages/UploadFiles/UploadFiles'
import { Button, ButtonGroup } from "@chakra-ui/react";
import EventFallbackImage from '../../images/event-fallback.png'

const EventCard = (props) => {
  return (
    <div className="Event-card-container">
      <article className="card">
    	<img src={EventFallbackImage} className="card-header" />
        <div className="card-body">
          <h2>{props.name}</h2>
          <p className="body-content">{props.description}</p>
          <p className="date">
            from{" "}
            <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
              {props.start_time}
            </span>{" "}
            on{" "}
            <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
              {props.start_date}
            </span>
            <br />
            to
            <br />
            <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
              {props.end_time}
            </span>{" "}
            on{" "}
            <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
              {props.end_date}
            </span>
          </p>
          <div
            className="options"
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center"
            }}
          >
            <div className="options">
              <Link to={`/gallery?eventid=${props.id}&eventname=${props.name}`} style={{margin: "1rem"}}>
                <Button colorScheme="blue">View Gallery</Button>
              </Link>
              <UploadFiles name={props.name} eventid={props.id} />
            </div>
          </div>
        </div>
      </article>
    </div>
  );
}

export default EventCard
